import type { CardStack } from '../../../stores/TimetableVersion/PinboardStoreTypes';
import type { CardType } from '../../TimetableVersion/graphql/types';

export type StackEntry = {
  /** Schlüssel des Stapels (Unterricht + Dauer) – bleibt beim Aufnehmen gleich, kein Neuaufbau in React. */
  key: string;
  /** Karte, die oben auf dem Stapel liegt (bei einem Platzhalter: die Karte in der Hand). */
  card: CardType;
  /** Karten, die noch im Stapel liegen – ohne die Karte in der Hand. */
  cards: CardType[];
  /** Die letzte Karte des Stapels ist in der Hand: nur ein blasser Platzhalter an ihrer Stelle. */
  placeholder: boolean;
};

/**
 * Baut die Einträge des Ablagestapels. `stacks` enthält die aus dem Stapel aufgenommene Karte noch
 * (`getCardsStack(pickedUuid)`), damit Reihenfolge und Stellen gleich bleiben wie vor dem Aufnehmen;
 * hier wird sie nur aus der Anzahl herausgerechnet. War sie die letzte Karte ihres Stapels, bleibt
 * ein Platzhalter stehen, damit die folgenden Stapel nicht nachrücken.
 */
export function buildStackEntries(stacks: CardStack, pickedUuid: string | null, searchString: string): StackEntry[] {
  const search = searchString.toLowerCase();
  const entries: StackEntry[] = [];
  stacks.forEach((stack, key) => {
    const subject = stack[0]?.subject?.shortName ?? '';
    if (search !== '' && !subject.toLowerCase().includes(search)) return;
    const cards = pickedUuid ? stack.filter((card) => card.uuid !== pickedUuid) : stack;
    if (cards.length === 0) {
      entries.push({ key, card: stack[0], cards, placeholder: true });
    } else {
      entries.push({ key, card: cards[0], cards, placeholder: false });
    }
  });
  // Nach Fachkürzel sortieren (stabil: gleiche Kürzel behalten die Reihenfolge des Stapels).
  return entries.sort((a, b) => (a.card.subject?.shortName ?? '').localeCompare(b.card.subject?.shortName ?? ''));
}
